interface LitterNames {
  name?: string | null;
  dogName?: string | null;
  studBoyName?: string | null;
}

/** "Hündin × Rüde" - die Elterntiere eines Wurfs. */
export const litterParents = ({ dogName, studBoyName }: LitterNames) => [dogName, studBoyName].filter(Boolean).join(' × ');

/** Anzeige eines Wurfs in Listen: der optionale Wurfname vorn, dahinter die Elterntiere. */
export const litterLabel = (litter: LitterNames) => {
  const parents = litterParents(litter);
  const name = litter.name?.trim();
  if (!name) return parents;
  return parents ? `${name} · ${parents}` : name;
};
